import React from 'react'
import { IIconProps } from './types'

const IconHeadSnowflake: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '24px'}
        width={props.width ? props.width : '24px'}
        fill={props.color ? props.color : '#000000'}
        viewBox='0 0 24.913 28'
      >
        <path
          id='head-snowflake'
          d='M18.008,3A10.893,10.893,0,0,0,7.12,13.36L4.133,17.3a.8.8,0,0,0,.653,1.26H7.12v4.667a3.1,3.1,0,0,0,3.111,3.111h1.556V31H22.675V23.7A10.875,10.875,0,0,0,18.008,3m6.316,10.22-3.049.809,2.24,2.256A1.4,1.4,0,1,1,21.54,18.26l-2.271-2.24-.793,3.049a1.371,1.371,0,0,1-1.7,1,1.387,1.387,0,0,1-1-1.711l.824-3.064-3.064.824a1.392,1.392,0,1,1-.716-2.691l3.049-.793-2.24-2.271a1.4,1.4,0,1,1,1.976-1.976l2.256,2.24.809-3.049a1.37,1.37,0,0,1,1.664-1A1.415,1.415,0,0,1,21.368,8.3l-.824,3.049,3.049-.824a1.415,1.415,0,0,1,1.727,1.027A1.37,1.37,0,0,1,24.324,13.22Z'
          transform='translate(-3.985 -3)'
          fill={props.color ? props.color : '#1b1b1d'}
        />
      </svg>
    </>
  )
}

export default IconHeadSnowflake
